{
  "$schema": "https://cogo.xyz/ontology/v1/flow-step-types",
  "version": "1.3.0",
  "description": "Valid ActionFlow step types and their structure",
  "triggerTypes": ["init", "lifecycle", "mount", "unmount", "onLoad", "onMount", "onBlockLoad"],
  "stepTypes": {
    "basic": {
      "description": "Execute a single action with params",
      "requiredFields": ["action"],
      "optionalFields": ["params", "resultTarget"],
      "canNest": false,
      "nestedStepFields": []
    },
    "action": {
      "description": "Execute a single action (alias for basic, used by bundle-injected flows)",
      "requiredFields": ["action"],
      "optionalFields": ["params", "resultTarget"],
      "canNest": false,
      "nestedStepFields": []
    },
    "conditional": {
      "description": "Branch execution based on condition",
      "requiredFields": ["condition"],
      "optionalFields": ["then", "else"],
      "canNest": true,
      "nestedStepFields": ["then", "else"]
    },
    "expression": {
      "description": "Evaluate expression and optionally store result",
      "requiredFields": [],
      "optionalFields": ["expression", "action", "params"],
      "canNest": false,
      "nestedStepFields": []
    },
    "loop": {
      "description": "Iterate over a collection",
      "requiredFields": ["collection"],
      "optionalFields": ["itemVar", "steps"],
      "canNest": true,
      "nestedStepFields": ["steps"]
    },
    "parallel": {
      "description": "Execute multiple steps concurrently",
      "requiredFields": [],
      "optionalFields": ["steps"],
      "canNest": true,
      "nestedStepFields": ["steps"]
    },
    "tryCatch": {
      "description": "Error handling and guaranteed cleanup with try/catch/finally blocks",
      "requiredFields": ["try"],
      "optionalFields": ["catch", "finally"],
      "canNest": true,
      "nestedStepFields": ["try", "catch", "finally"]
    },
    "switch": {
      "description": "Multi-branch switch on value",
      "requiredFields": ["value"],
      "optionalFields": ["cases", "default"],
      "canNest": true,
      "nestedStepFields": ["default"]
    },
    "stage": {
      "description": "Ordered lifecycle boundary; not an ACID database transaction",
      "requiredFields": ["name", "steps"],
      "optionalFields": ["onEnter", "onSuccess", "onError", "onFinally", "compensate", "failurePolicy"],
      "canNest": true,
      "nestedStepFields": ["onEnter", "steps", "onSuccess", "onError", "onFinally", "compensate"]
    },
    "saga": {
      "description": "Ordered stages with reverse compensation of completed stages on failure",
      "requiredFields": ["stages"],
      "optionalFields": ["compensationFailurePolicy"],
      "canNest": true,
      "nestedStepFields": ["stages"]
    }
  }
}
